import { API_ROUTES } from "../apiRoutes";
import { HttpClient } from "../HttpClient";
import { REQUEST_METHODS } from "../configs.apiClient";

import * as EventInterfaces from "@/types/event.types";
import {
  GetUserEventsResponse,
  PostUserEventRequest,
  UserMilestoneEnum,
} from "@/types/event.types";
import { UserPropertiesOptions } from "@/types/user.types";
import { captureError } from "@/utils/common.helpers";
import { langDetails, LangEnum } from "@/constants/constants";

export class EventAPIClient {
  private httpClient: HttpClient;

  constructor(httpClient: HttpClient) {
    this.httpClient = httpClient;
  }

  async updateUserProperties(
    dialect: string,
    lang: string,
    options?: UserPropertiesOptions,
  ) {
    try {
      const finalDialect = dialect;
      const method = REQUEST_METHODS.POST;
      const endpoint = API_ROUTES.event.updateUserProperties;

      const body: Record<string, string> = {
        language: langDetails[LangEnum.HI].apiKey,
        primaryLanguage: finalDialect.slice(0, 3),
      };

      if (options?.fbc) body.fbc = options.fbc;
      if (options?.fbp) body.fbp = options.fbp;
      if (options?.utm_source) body.utm_source = options.utm_source;
      if (options?.utm_medium) body.utm_medium = options.utm_medium;
      if (options?.utm_campaign) body.utm_campaign = options.utm_campaign;
      if (options?.deeplink) body.deeplink = options.deeplink;

      const response =
        await this.httpClient.request<EventInterfaces.UpdateUserPropertiesInterface>(
          {
            endpoint,
            options: {
              method,
            },
            lang,
            dialect: finalDialect,
            body,
          },
        );

      return response?.data;
    } catch (error) {
      console.error("Error in EventAPIClient updateUserProperties", error);
      throw captureError(error);
    }
  }

  async getUserEvents(): Promise<GetUserEventsResponse | null> {
    try {
      const method = REQUEST_METHODS.GET;
      const endpoint = API_ROUTES.userEvents;

      const response = await this.httpClient.nestRequest<GetUserEventsResponse>(
        {
          endpoint,
          options: {
            method,
          },
          addToken: true,
        },
      );

      return response;
    } catch (error) {
      console.error("Error in EventAPIClient getUserEvents", error);
      captureError(error);
      return null;
    }
  }

  async postUserEvent(
    eventName: UserMilestoneEnum,
    metadata: PostUserEventRequest["metadata"],
  ): Promise<boolean> {
    try {
      const method = REQUEST_METHODS.POST;
      const endpoint = API_ROUTES.userEvents;

      const body = {
        eventName,
        metadata,
      } as Record<string, string | object>;

      await this.httpClient.nestRequest<{ success: boolean }>({
        endpoint,
        options: {
          method,
        },
        addToken: true,
        body,
      });

      return true;
    } catch (error) {
      console.error("Error in EventAPIClient postUserEvent", error);
      captureError(error);
      return false;
    }
  }
}
